const SwapElements = (array,setArray,onChange,field,index , type)=>{
    const reordered = JSON.parse(JSON.stringify(array));
    switch (type) {
      case 'up' :
        if (index !== 0) {
          const [removed] = reordered.splice(index, 1);
          reordered.splice(index - 1, 0, removed);
          console.log(reordered);
       
        }
        break;
      case 'down' : 
        if (index < array.length) {
          const [removed] = reordered.splice(index, 1);
          reordered.splice(index + 1, 0, removed);
          console.log(reordered)
        }
        break;
      default :
        console.log('bad type in reordering')
    }
    setArray([])
    onChange(field , reordered)
    setTimeout(()=>{
      setArray(JSON.parse(JSON.stringify(Array.from(reordered))));
    } , 1)


  }
const reorder = (array,setArray,onChange,field,index)=>{
    return {
        up :  index !== 0 ? ()=>{ SwapElements(array,setArray,onChange,field,index ,  'up') }: null,
        down : index < array.length - 1 ? ()=> {SwapElements(array,setArray,onChange,field,index , 'down')} : null
    }
}
export default reorder;